import classNames from "classnames";
import React from "react";

import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

type Props = {
  value: string;
  slots: string[];
  readOnly: boolean;
  onChange: (value: string) => void;
  error: string | null;
};

export const ECTimePicker = ({ slots, readOnly, onChange, value, error }: Props) => {
  const [selectedTime, setSelectedTime] = React.useState<string>(value);

  React.useEffect(() => {
    setSelectedTime(value);
  }, [value]);

  if (readOnly) {
    return (
      <div className="cw-px-1 cw-py-[2px] cw-text-default cw-body-sm cw-font-medium">
        {selectedTime}
      </div>
    );
  }

  return (
    <Autocomplete
      value={selectedTime}
      className="cw-w-[90px] cw-h-7"
      id="cw-event-card-time-picker"
      onInputChange={(_e, v) => {
        setSelectedTime(v);
        onChange(v);
      }}
      freeSolo
      options={slots}
      renderOption={(option) => <div className="cw-text-13">{option}</div>}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            type: "search",
            disableUnderline: true,
            endAdornment: null,
            startAdornment: null,
            className: classNames(
              "cw-h-8 cw-text-13 cw-font-medium",
              "cw-box-border",
              "cw-px-1 cw-py-1",
              "cw-border cw-border-solid",
              "cw-font-body",
              "cw-rounded",
              "cw-transition",
              "cw-outline-1",
              "cw-text-default placeholder:cw-text-subtle",
              "cw-bg-default cw-border-[#FFF] hover:cw-border-subtle-hover focus:cw-border-brand-interactable focus:hover:cw-border-brand-interactable-hover focus-visible:cw-outline-brand-interactable focus:cw-outline-brand-interactable focus:hover:cw-outline-brand-interactable-hover",
              {
                "cw-bg-destructive cw-outline cw-border-destructive-interactable cw-outline-destructive-interactable hover:cw-border-destructive-interactable-hover hover:cw-outline-destructive-interactable-hover focus-visible:cw-outline-destructive-interactable-pressed focus:cw-outline-destructive-interactable-pressed": error,
              },
            ),
          }}
        />
      )}
    />
  );
};
